import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core"
import React from "react"
import useAppStore from "../../stores/AppStore"
import Cabecalho from "../Cabecalho"
import { PDVozEditor } from "./PDVozEditor"

const useStyles = makeStyles({
    shell: {
        minHeight: "100vh",
        backgroundColor: "#eceff1",
        paddingInline: "1rem",
        paddingBottom: "2rem",
    },
})

export default function PDVoz() {
    const classes = useStyles()
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("md"))

    const idEstabelecimento = useAppStore(
        s => s.configuracoes?.user?.parametros?.estabelecimento?.id
    )

    if (!idEstabelecimento) return null

    return (
        <main
            className={classes.shell}
            style={{
                marginLeft: mobile ? "" : "80px",
                paddingTop: "0.5rem",
            }}
        >
            <Cabecalho pagina="PDVoz" subtitulo="Cadastros" />
            <PDVozEditor idEstabelecimento={idEstabelecimento} />
        </main>
    )
}
